/**
 * HubSpot form loader.
 *
 * The iubenda cookie banner uses automatic blocking, which rewrites the
 * HubSpot embed script tag to type="text/plain" until consent is given and
 * only releases it later, asynchronously. The old embeds called
 * hbspt.forms.create() from an inline script right after the tag, so that call
 * always ran before (or instead of) the embed script and threw
 * "hbspt is not defined" — leaving an empty gap where the form should be.
 *
 * This loader waits until hbspt actually exists, then renders every registered
 * form into its own container. It keeps polling so a form also appears when the
 * visitor accepts cookies without reloading the page.
 */
(function () {
  if (window.__brmHubSpotForms) return;

  var POLL_MS = 250;
  var TIMEOUT_MS = 20000;
  var timer = null;
  var elapsed = 0;

  function containers() {
    return document.querySelectorAll('[data-hs-form]:not([data-hs-form-state])');
  }

  function create(el) {
    el.setAttribute('data-hs-form-state', 'loading');

    var options = {
      portalId: el.getAttribute('data-hs-portal'),
      formId: el.getAttribute('data-hs-form'),
      target: '#' + el.id
    };

    var region = el.getAttribute('data-hs-region');
    if (region) options.region = region;

    try {
      window.hbspt.forms.create(options);
      el.setAttribute('data-hs-form-state', 'ready');
    } catch (error) {
      el.setAttribute('data-hs-form-state', 'error');
      console.error('[hubspot-forms] could not create form', options.formId, error);
    }
  }

  function showFallback(el) {
    if (el.getAttribute('data-hs-form-state')) return;
    el.setAttribute('data-hs-form-state', 'blocked');

    var fallback = el.querySelector('[data-hs-form-fallback]');
    if (fallback) fallback.hidden = false;
  }

  function tick() {
    var pending = containers();

    if (!pending.length) {
      stop();
      return;
    }

    if (window.hbspt && window.hbspt.forms) {
      for (var i = 0; i < pending.length; i++) create(pending[i]);
      stop();
      return;
    }

    elapsed += POLL_MS;
    if (elapsed >= TIMEOUT_MS) {
      for (var j = 0; j < pending.length; j++) showFallback(pending[j]);
      stop();
    }
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    if (timer || !containers().length) return;
    elapsed = 0;
    timer = setInterval(tick, POLL_MS);
    tick();
  }

  window.__brmHubSpotForms = { start: start };

  // Consent can be given long after the timeout, so restart the poll then.
  ['iubenda_consent_given', 'iubenda_preference_expressed'].forEach(function (event) {
    document.addEventListener(event, function () {
      var blocked = document.querySelectorAll('[data-hs-form][data-hs-form-state="blocked"]');
      for (var i = 0; i < blocked.length; i++) blocked[i].removeAttribute('data-hs-form-state');
      start();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Sections added by the theme editor.
  document.addEventListener('shopify:section:load', start);
})();
